import React from 'react';
import { useVoteStore } from '../../stores/voteStore';
import { voteTiers } from '../../config/voteTiers';
import { formatCurrency } from '../../utils/formatters';

export const VoteTiers = () => {
  const { selectedTier, setSelectedTier } = useVoteStore();

  return (
    <div className="grid gap-4 sm:grid-cols-2">
      {voteTiers.map((tier) => (
        <button
          key={tier.votes}
          onClick={() => setSelectedTier(tier)}
          className={`flex flex-col items-center justify-center p-4 rounded-lg border-2 transition-all ${
            selectedTier?.votes === tier.votes
              ? 'border-indigo-600 bg-indigo-50'
              : 'border-gray-200 hover:border-indigo-200'
          }`}
        >
          <span className="text-2xl font-bold text-indigo-600">
            {tier.votes} votes
          </span>
          <span className="text-gray-600 mt-1">
            {formatCurrency(tier.amount)} XAF
          </span>
          {tier.bonus > 0 && (
            <span className="text-green-600 text-sm mt-1">
              +{tier.bonus} votes bonus !
            </span>
          )}
        </button>
      ))}
    </div>
  );
};